import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import GroupWarning from "../../commoncomponents/groupWarning";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Button } from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import { setLoadingPage, setErrorMessage, setHeaderVisible, setReportAssetId, setReportCalendatDate, setReportAssetName, setReportGroupId } from "../../../reducers/actions";
import { connect } from "react-redux";
import Select from "react-select";
import Summary from "../common/summary";
import ReportDisplayControls, { getSavedSummaryLayout } from "../common/ReportDisplayControls";
import Triplog from "./triplog";
import VirtualTrips from "./virtualTrips";
import OverSpeedException from "./overspeedExceptions";
import GeneralException from "./generalException";
import GeooverlayExceptions from "./geooverlayExceptions";
import RawMessagesEvents from "./rawMessagesEvents";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import TemperatureExceptions from "./temperatureExceptions";
import ParkIdleExceptions from "./parkedIdleExceptions";
import queryString from "query-string";

const REPORT_FILTERING_STORAGE_KEY = "reportUseFiltering";

const getSavedReportFilteringState = () => {
  const savedValue = localStorage.getItem(REPORT_FILTERING_STORAGE_KEY);
  return savedValue === null ? true : savedValue !== "false";
};

const getReportFilteringQueryValue = (values) => {
  const queryValue = values.UseFiltering || values.useFiltering || values.filtering;
  if (queryValue === undefined) {
    return null;
  }

  const normalisedValue = String(queryValue).toLowerCase();
  return normalisedValue !== "false" && normalisedValue !== "0";
};

class MVTRIPLOG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summaryModern: getSavedSummaryLayout(),
      assetPlaceholder: "Select Asset",
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: moment().format("YYYY-MM-DD"),
      calendarSelectedDate: new Date(),
      calendarShow: false,
      checked: getSavedReportFilteringState(),
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      isLoading: false,
      loadedReportParams: null
    };
    this.groupId = "";

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const searchDate = values.assetDate || values.SearchDate || values.searchDate;
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const useFiltering = getReportFilteringQueryValue(values);
    const urlState = {};

    if (useFiltering !== null) {
      urlState.checked = useFiltering;
      localStorage.setItem(REPORT_FILTERING_STORAGE_KEY, String(useFiltering));
    }

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      if (searchDate !== undefined && searchDate !== "null") {
        urlState.dataPlaceholder = moment(searchDate).format("dddd Do MMMM, YYYY");
        urlState.ReportDate = searchDate;
        urlState.calendarSelectedDate = moment(searchDate).toDate();
      }
      urlState.assetPlaceholder = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetId = assetId;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      }
      else {
        this.setState({ isLoading: true });
      }
      // this.setState({ groupDetails: GroupList.data });
    } catch (e) {
      console.warn("Report request failed");
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        assetId: "",
        AssetList: [],
        assetLoader: false,
      });
      this.props.setReportGroupIdAction("");
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      groupCustomerName: group.customername,
      groupGeneralName: group.groupName,
      assetCustomerName: "",
      assetGeneralName: "",
      assetPlaceholder: "Select Asset",
      assetId: "",
      AssetList: [],
      assetLoader: true,
    });
    this.props.setReportGroupIdAction(group.groupId);
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetCustomerName: asset.name,
      assetGeneralName: asset.customerName,
      assetPlaceholder: asset.name,
    });
  };

  isDoorSensorAsset = () => {
    const reportDetails = this.state.reportDetails || {};
    if (reportDetails.doorSensor || reportDetails.DoorSensor) return true;

    const selectedAsset = this.state.AssetList.find((asset) => asset.assetId == this.state.assetId);
    return !!(selectedAsset && (selectedAsset.doorSensor || selectedAsset.DoorSensor));
  };

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    this.setState({
      calendarSelectedDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  handleCheckup = () => {
    this.setState((prevState) => {
      const checked = !prevState.checked;
      localStorage.setItem(REPORT_FILTERING_STORAGE_KEY, String(checked));
      return { checked };
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getQuickReportUrl = (path) => {
    const assetName = this.state.assetCustomerName || this.state.assetPlaceholder || "";
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName,
      SearchDate: this.state.ReportDate,
      assetDate: this.state.ReportDate,
      UseFiltering: String(this.state.checked),
    });

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  handleCreateReport = async () => {
    this.setState({
      reportDetails:[],
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
    });
    let assetID = this.state.assetId;
    let assetName = this.state.assetCustomerName;
    this.props.setReportAssetIdAction(assetID);
    this.props.setReportAssetNameAction(assetName);
    this.props.setReportCalendatDateAction(this.state.ReportDate);
    this.props.setReportGroupIdAction(this.state.groupId);
    this.updateCurrentReportUrl();
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        reportDate: this.state.ReportDate,
        groupId: this.state.groupId,
        checked: this.state.checked,
      },
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/MVTripLog`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: this.state.checked,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });      
      
      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.warn("Report request failed");
    }
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetPlaceholder,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetPlaceholder,
              customerName: this.state.assetGeneralName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.reportDate !== this.state.ReportDate ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
        loadedReportParams.checked !== this.state.checked
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        ref={this.setWrapperRef}
        className="ParentCalender"
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            onChange={this.onChangeDate}
            value={this.state.calendarSelectedDate}
          />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <Layout>
        <Helmet>
          <title>MVTL</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page mvtl-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page mvtl-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">
                    Motor Vehicle Trip Log
                  </h2>
                  <p>Review trips, exceptions, raw events and vehicle activity for a selected asset and day.</p>
                </div>
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="reportQuickActions">
                  <span className="reportQuickActionsLabel">Quick reports</span>
                  <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Replay")}>Replay</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                  <span className="reportQuickActionsSpacer" />
                  <ReportDisplayControls modern={this.state.summaryModern} onLayoutChange={summaryModern => this.setState({ summaryModern })} filtering={this.state.checked} onFilteringChange={this.handleCheckup} />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  {this.state.assetId != "" ? (
                    <Button
                      className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                      variant="primary"
                      onClick={this.handleCreateReport}
                      size="sm"
                    >
                      <i className="fa fa-bar-chart"></i>
                      Create Report
                    </Button>
                  ) : (
                    <Button
                      className="reportPickerCreateButton"
                      variant="primary"
                      onClick={this.handleCreateReport}
                      size="sm"
                      disabled
                    >
                      <i className="fa fa-bar-chart"></i>
                      Create Report
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <AssetInforWarning
                    warningText={true}
                    warningTextMsg="No Data Available"
                  />
                ) : (
                  <React.Fragment>
                    {this.state.reportDetails.processed != 0 ? (
                      <React.Fragment>
                        <Summary allowLayoutToggle modernLayout={this.state.summaryModern}
                          reportDetail={this.state.reportDetails}
                          generatedDate={this.state.generatedDate}
                        />
                        {this.state.reportDetails.trips != null &&
                          typeof this.state.reportDetails.trips !==
                          "undefined" &&
                          this.state.reportDetails.trips.length > 0 &&
                          this.state.reportDetails.trips != [] && (
                            <Triplog
                              reportDetail={this.state.reportDetails.trips}
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              tempBEnabled={this.state.reportDetails.tempB}
                              tempAEnabled={this.state.reportDetails.tempA}
                              driverIDEnabled={this.state.reportDetails.driverID}
                              assetId={this.state.assetId}

                            />
                          )}
                        {this.state.reportDetails.virtualTrips != null &&
                          typeof this.state.reportDetails.virtualTrips !=
                          "undefined" &&
                          this.state.reportDetails.virtualTrips.length > 0 && (
                            <VirtualTrips
                              reportDetail={this.state.reportDetails.virtualTrips}
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              assetId={this.state.assetId}
                            />
                          )}
                        {this.state.reportDetails.temperatureExceptions !=
                          null &&
                          typeof this.state.reportDetails
                            .temperatureExceptions != "undefined" &&
                          this.state.reportDetails.temperatureExceptions
                            .length > 0 && (
                            <TemperatureExceptions
                              temperatureAThreshold={
                                this.state.reportDetails.temperatureAThreshold
                              }
                              temperatureBThreshold={
                                this.state.reportDetails.temperatureBThreshold
                              }
                              reportDetail={
                                this.state.reportDetails.temperatureExceptions
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              tempBEnabled={this.state.reportDetails.tempB}
                              tempAEnabled={this.state.reportDetails.tempA}
                              assetId={this.state.assetId}
                            />
                          )}
                        {this.state.reportDetails.parkedIdleExceptions !=
                          null &&
                          typeof this.state.reportDetails
                            .parkedIdleExceptions != "undefined" &&
                          this.state.reportDetails.parkedIdleExceptions.length >
                          0 && (
                            <ParkIdleExceptions
                              reportDetail={
                                this.state.reportDetails.parkedIdleExceptions
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              assetId={this.state.assetId}
                            />
                          )}
                        {this.state.reportDetails.speedExceptions != null &&
                          typeof this.state.reportDetails.speedExceptions !=
                          "undefined" &&
                          this.state.reportDetails.speedExceptions.length > 0 &&
                          this.state.reportDetails.speedExceptions != [] && (
                            <OverSpeedException
                              reportDetail={
                                this.state.reportDetails.speedExceptions
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              assetId={this.state.assetId}
                            />
                          )}
                        {this.state.reportDetails.generalExceptionsIbutton != null &&
                          typeof this.state.reportDetails.generalExceptionsIbutton !=
                          "undefined" &&
                          this.state.reportDetails.generalExceptionsIbutton
                          .length >
                          0 && (
                            <GeneralException
                              reportDetail={
                                this.state.reportDetails.generalExceptionsIbutton
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              tempBEnabled={this.state.reportDetails.tempB}
                              tempAEnabled={this.state.reportDetails.tempA}
                              driverIDEnabled={this.state.reportDetails.driverID}
                              assetId={this.state.assetId}
                            />
                          )}
                        {this.state.reportDetails.geoOverlayEvents != null &&
                          typeof this.state.reportDetails.geoOverlayEvents !=
                          "undefined" &&
                          this.state.reportDetails.geoOverlayEvents.length >
                          0 && (
                            <GeooverlayExceptions
                              reportDetail={
                                this.state.reportDetails.geoOverlayEvents
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              tempBEnabled={this.state.reportDetails.tempB}
                              tempAEnabled={this.state.reportDetails.tempA}
                              driverIDEnabled={this.state.reportDetails.driverID}
                              doorSensorEnabled={this.isDoorSensorAsset()}
                              assetId={this.state.assetId}
                            />
                          )}

                        {this.state.reportDetails.rawMessagesEvents != null &&
                          typeof this.state.reportDetails.rawMessagesEvents !=
                          "undefined" &&
                          this.state.reportDetails.rawMessagesEvents.length >
                          0 && (
                            <RawMessagesEvents
                              reportDetail={
                                this.state.reportDetails.rawMessagesEvents
                              }
                              assetCustomerName={this.state.assetCustomerName}
                              calendarSelectedDate={this.state.calendarSelectedDate}
                              tempBEnabled={this.state.reportDetails.tempB}
                              tempAEnabled={this.state.reportDetails.tempA}
                              driverIDEnabled={this.state.reportDetails.driverID}
                              assetId={this.state.assetId}
                            />
                          )}
                      </React.Fragment>
                    ) : (
                      <AssetInforWarning
                        warningText={true}
                        warningTextMsg="No Data Available"
                      />
                    )}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

// const HighlightedDetailTab=(props)=>{
// return(

//     <div className="highlightedDetailBody" onClick={props.functionCall}>
//         <i className="fa fa-th"></i>
// <p>{props.customerName}<span>{props.generalName}</span>({props.count})</p>
// <i className="fa fa-caret-down"></i>
//     </div>
//     )
// }

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(MVTRIPLOG);
